export const IMAGE_EXTENSIONS = ['.jpeg', '.jpg', '.png', '.webp', '.dib', '.bmp', '.tif', '.tiff', '.avif', '.jpe'] as const;
export const IMAGE_FILE_ACCEPT = IMAGE_EXTENSIONS.join(',');
export const IMAGE_MAX_SIZE = 50 * 1024 * 1024; // 50MB
export const IMAGE_MAX_DIMENSION = 15000; // 最大宽高 15000px

export const VIDEO_EXTENSIONS = ['.mov', '.mp4'] as const;
export const VIDEO_FILE_ACCEPT = VIDEO_EXTENSIONS.join(',');
export const VIDEO_MAX_SIZE = 1.5 * 1024 * 1024 * 1024; // 1.5GB
export const VIDEO_MAX_DURATION = 15 * 60; // 15 mins

export const AUDIO_EXTENSIONS = ['.mp3', '.wav'] as const;
export const AUDIO_FILE_ACCEPT = AUDIO_EXTENSIONS.join(',');
export const AUDIO_MAX_SIZE = 1.5 * 1024 * 1024 * 1024; // 1.5GB
export const AUDIO_MAX_DURATION = 15 * 60; // 15 mins

export const TEXT_EXTENSIONS = ['.txt', '.md', '.json', '.csv'] as const;
export const TEXT_FILE_ACCEPT = TEXT_EXTENSIONS.join(',');
export const TEXT_MAX_SIZE = 100 * 1024; // 100KB

export const TEXT_MAX_CHARACTERS = 100000; // 10万字符

export function formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}
